/**
 * @type {Object}
 * @property {array}
 */
const initialState = {
    paymentMethods: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerPaymentMethod = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_PAYMENT_METHODS_DATA':
            var { data } = action;
            newState.paymentMethods = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerPaymentMethod;